import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TripDataService {

  constructor(private http: HttpClient) { }

  getTripById = (tripId: number, projectId: number): Promise<any> => {
    return this.http.get<any>(`${environment.api.baseUrl}/${environment.api.endpoints.trip.trip}/${projectId}/${tripId}`).toPromise();
  }
}
